/* ============================================================================
   RT ADAPTIVE - device tier detector  v1.0  (15 Jul 2026)
   ----------------------------------------------------------------------------
   Companion to rt-adaptive.css. Adds class "rt-lite" to <html> ONLY on
   low-spec / data-saving devices. On everything else it does nothing at all.

   Why iPhone and normal desktops are safe:
     - navigator.deviceMemory  : Chrome/Android only, undefined on Safari
     - navigator.connection    : Chrome/Android only, undefined on Safari
     - hardwareConcurrency gate: applied only when the UA is Android
   So Safari/iPhone can never qualify, and desktops qualify only if they
   genuinely have 3GB RAM or less.

   The window.__rtMVLoaded flag is the loader guard that already exists in
   sections/browse-our-range.liquid. Setting it before that script runs means
   the 3D model-viewer library and both .glb models are never downloaded on
   lite devices (saves roughly 1MB+ and two permanent WebGL render loops).

   INSTALL (must run BEFORE body sections, i.e. inside <head>):
     Upload as an asset, then add ONE line in layout/theme.liquid right after
     the small inline <script> that swaps the no-js class (around line 133):

       <script src="{{ 'rt-adaptive.js' | asset_url }}"></script>

     Intentionally NOT defer: it must set the flag before section scripts run.
     The file is under 1KB so the cost is negligible.
   ============================================================================ */
(function () {
  try {
    var n = navigator;
    var ua = n.userAgent || '';
    var conn = n.connection || n.mozConnection || n.webkitConnection;
    var lite = false;

    /* User explicitly asked the browser to save data */
    if (conn && conn.saveData) lite = true;

    /* Very slow network: skip 3D and heavy effects regardless of CPU */
    if (conn && /(slow-2g|2g|3g)$/.test(conn.effectiveType || '')) lite = true;

    /* 3GB RAM or less (Chrome-only API; undefined elsewhere) */
    if (n.deviceMemory && n.deviceMemory <= 3) lite = true;

    /* Budget Android CPUs: 4 cores or fewer, Android only */
    if (/Android/i.test(ua) && n.hardwareConcurrency && n.hardwareConcurrency <= 4) {
      lite = true;
    }

    if (!lite) return;

    document.documentElement.classList.add('rt-lite');

    /* Existing guard in browse-our-range.liquid: with this set, loadMV()
       returns immediately and the model-viewer library never loads. */
    window.__rtMVLoaded = true;
  } catch (e) { /* never break the page over an optimization */ }
})();